import type { ColumnDef } from "@tanstack/react-table"
import type { OtkDestructionAct } from "shared"

import { Status } from "@/components/Status"
import { destructionActStatusLabels } from "@/lib/destructionAct"
import { formatCommissionMember, formatUaDate } from "@/lib/warehouse"

/**
 * warehouse-acts.md's acts-list column set — the number is the row's own
 * view trigger (a link-styled button, not a separate actions column), so
 * the builder needs `onViewAct` the way `buildWarehouseColumns` needs it.
 * `table-auto` + `w-px` on every fixed column with «Місце проведення» as
 * the sole `w-full` one, same technique `buildWarehouseColumns` already
 * uses for «Анульовані».
 */
export function buildActColumns(
  onViewAct: (actId: string) => void
): ColumnDef<OtkDestructionAct>[] {
  return [
    {
      accessorKey: "actNumber",
      header: "№ акту",
      meta: { className: "w-px" },
      cell: ({ row }) => (
        <button
          aria-label={`Переглянути акт знищення № ${row.original.actNumber}`}
          className="font-medium text-primary hover:underline"
          onClick={() => onViewAct(row.original.id)}
          type="button"
        >
          {row.original.actNumber}
        </button>
      ),
    },
    {
      accessorKey: "actDate",
      header: "Дата акту",
      meta: { className: "w-px" },
      cell: ({ row }) => formatUaDate(row.original.actDate),
    },
    {
      id: "period",
      header: "Період",
      meta: { className: "w-px" },
      cell: ({ row }) =>
        `${formatUaDate(row.original.dateFrom)} – ${formatUaDate(row.original.dateTo)}`,
    },
    {
      accessorKey: "location",
      header: "Місце проведення",
      meta: { className: "w-full max-w-0 min-w-40" },
      cell: ({ row }) => (
        <span className="block truncate">{row.original.location}</span>
      ),
    },
    {
      id: "commissionChair",
      header: "Голова комісії",
      meta: { className: "w-px" },
      cell: ({ row }) => formatCommissionMember(row.original.commissionChair),
    },
    {
      id: "blankCount",
      header: "К-сть бланків",
      meta: { className: "w-px" },
      cell: ({ row }) => row.original.items.length,
    },
    {
      accessorKey: "status",
      header: "Статус",
      meta: { className: "w-px" },
      cell: ({ row }) => (
        <Status>{destructionActStatusLabels[row.original.status] ?? row.original.status}</Status>
      ),
    },
  ]
}
